export default function B2BvsB2C() {
  const b2cTraits = [
    { icon: 'ri-emotion-line', text: 'Эмоциональное решение' },
    { icon: 'ri-user-line', text: '1 человек принимает решение' },
    { icon: 'ri-flashlight-line', text: 'Быстрая покупка' },
    { icon: 'ri-timer-line', text: 'Короткий цикл сделки' },
    { icon: 'ri-money-dollar-circle-line', text: 'Цена — главный фактор' },
  ];

  const b2bTraits = [
    { icon: 'ri-brain-line', text: 'Взвешенное решение' },
    { icon: 'ri-team-line', text: 'Несколько ЛПР' },
    { icon: 'ri-briefcase-line', text: 'Сложная покупка' },
    { icon: 'ri-calendar-2-line', text: 'Длинный цикл сделки' },
    { icon: 'ri-file-list-3-line', text: 'Тендеры' },
    { icon: 'ri-check-double-line', text: 'Согласования' },
    { icon: 'ri-hand-heart-line', text: 'Отношения и доверие' },
    { icon: 'ri-customer-service-2-line', text: 'Послепродажное сопровождение' },
    { icon: 'ri-alert-line', text: 'Высокие риски' },
  ];

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-teal-50 text-teal-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            <i className="ri-scales-3-line"></i>
            Ключевое отличие
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Почему B2B продажи сложнее B2C
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Продажа бизнесу принципиально отличается от продажи частному лицу. Большинство техник из B2C здесь практически не работают.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 max-w-5xl mx-auto">
          <div className="bg-gray-50 rounded-2xl p-6 md:p-8 border border-gray-100">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-amber-100 rounded-xl flex items-center justify-center flex-shrink-0">
                <i className="ri-user-line text-2xl text-amber-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900">B2C продажи</h3>
            </div>
            <div className="space-y-3">
              {b2cTraits.map((item, i) => (
                <div key={i} className="flex items-center gap-3 bg-white rounded-lg p-3 border border-gray-100">
                  <div className="w-8 h-8 bg-amber-50 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className={`${item.icon} text-amber-600 text-sm`}></i>
                  </div>
                  <span className="text-sm text-gray-700">{item.text}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-teal-50/50 rounded-2xl p-6 md:p-8 border border-teal-100">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-teal-600 rounded-xl flex items-center justify-center flex-shrink-0">
                <i className="ri-building-2-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900">B2B продажи</h3>
            </div>
            <div className="space-y-3">
              {b2bTraits.map((item, i) => (
                <div key={i} className="flex items-center gap-3 bg-white rounded-lg p-3 border border-teal-100">
                  <div className="w-8 h-8 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className={`${item.icon} text-teal-600 text-sm`}></i>
                  </div>
                  <span className="text-sm text-gray-700">{item.text}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="max-w-3xl mx-auto mt-10 bg-teal-600/5 rounded-2xl p-6 md:p-8 text-center border border-teal-100">
          <p className="text-base md:text-lg text-gray-700 leading-relaxed">
            <strong className="text-teal-700">Именно поэтому</strong> большинство техник из B2C — «продажа выгоды», «презентация продукта», «работа с возражением по цене» — в сложных корпоративных продажах <strong className="text-teal-700">практически не работают</strong>. B2B требует другого мышления, другой подготовки и другой системы.
          </p>
        </div>
      </div>
    </section>
  );
}